import fetchAPI from 'utils/fetchAPI';

export const sendReferral = ({ contacts, subject, message }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: '/users/referral_code/invitation',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'POST',
      body: JSON.stringify({ contacts, subject, message }),
    })
      .then(res => res.json())
      .then(json => {
        if (json.status_code && json.status_code !== 200) {
          reject(json.error);
        }
        resolve(json);
      });
  });



// WEBPACK FOOTER //
// ./app/actions/SendReferralActionCreator.js